module.exports = "//public.zight.com/packs/media/images/icons-settings-blue-acad62aea9e6fe2524769671971ef583.svg";